<!-- <mat-toolbar class="secondary-toolbar mat-elevation-z1">
</mat-toolbar>

<section class="main-content"> -->

  <cw-dialog [title]='dialogTitle'>
    <div style="height:285px">{{dialogMessage}}</div>
    <button *ngIf="showPaymentButton" mat-raised-button type="button" color="primary" (click)="buyNow()">{{paymentButtonText}}</button>
  </cw-dialog>
<!-- </section> -->